/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import ImageMask from "../../assets/img/login/register-mask.png";
import {ReactComponent as Email} from "../../assets/img/forms/email.svg";
import {ReactComponent as Eye} from "../../assets/img/forms/eye.svg";
import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
import {ReactComponent as ArrowRight} from "../../assets/img/icons/arrow-right-white.svg";
import {Link} from "react-router-dom";
import PageBox from "../../layouts/pageBox";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import useAxiosJTW from "../../Hooks/useAxiosJTW";

const ForgotPass = () => {

    const { t, i18n } = useTranslation();
    const axiosJWT = useAxiosJTW();

    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const { control, register, handleSubmit, watch, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange",
    });

    const remindpassword = (data, signal) => {
        setError(false);
        setSuccess(false);
        axiosJWT.post('api/passwordreminder', { email: data.forgotPass }, {signal}).then( (response) => {
            if(response.data.success){
                if(!response.data.email_exists){
                    setError(true);
                }else{
                    setSuccess(true);
                }
            }
        } ).catch((error) => {
            console.log(error);
            setError(true);
        });
    }


    const onSubmit = data => {
        const controller = new AbortController();
        const signal= controller.signal;

        remindpassword(data, signal);

        return () => {controller.abort();}
    };

    const data = {
        title: '',
        subtitle: ''
    };

    return (
        <PageBox data={data} small={true}>
            <div className='page-body'>
                <div className='login-row'>

                    <div className='login'>
                        <div className='login__title'>{t('fields.forgotPassword')}</div>
                        <div className='login__text'>{t('fields.forgotPasswordtext')}</div>
                        <form className='login-form' onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group">
                                <label htmlFor='loginEmail'>Email</label>
                                <div className='form-group__wrap'>
                                    <input id='loginEmail' className="form-control" type="email" {...register("forgotPass",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.emailPlace')}/>
                                    <span className='form-group__icon'><Email/></span>
                                </div>
                                { errors.forgotPass && <small className="text-danger">{errors.forgotPass?.message}</small>}
                            </div>
                            <button type="submit" className='btn btn-primary btn-icon btn-block'>{t('fields.resetLink')}</button>

                            {error && <div className="text-danger pt-3">{t('fields.emailnotfound')}</div>}
                            {success && <div className="text-success pt-3">{t('fields.emailverification')}</div>}

                            <Link to={`/${i18n.language}/login`} className='mixed-link__link pt-5 d-block'>{t('fields.login')}</Link>
                        </form>
                    </div>

                </div>
            </div>
        </PageBox>
    );
};

export default ForgotPass;
